import { useMemo } from "react";
import { Image, StyleSheet } from "react-native";

interface Props {
  size?: "default" | "xl";
}
export function Logo({ size }: Props) {
  const sizeStyle = useMemo(() => {
    switch (size) {
      case "xl":
        return styles.logoXl;
      default:
        return styles.logo;
    }
  }, [size]);
  const imageSource = useMemo(() => {
    switch (size) {
      case "xl":
        return require("app/assets/icareLogoLarge.png");
      default:
        return require("app/assets/icareLogoColor.png");
    }
  }, [size]);
  return <Image source={imageSource} style={sizeStyle} />;
}

const styles = StyleSheet.create({
  logo: {
    height: 30,
    width: 72,
  },
  logoXl: {
    height: 30 * 3,
    width: 72 * 3,
  },
});
